/** Bounded SSE decoding shared by private inference and browser chat clients. */
export async function readEventStream(response: Response, onEvent: (event: { event: string; data: string }) => boolean | void | Promise<boolean | void>, signal?: AbortSignal, maxBytes = 2_000_000): Promise<void> {
  if (!response.body) throw new Error('The reply stream is unavailable.');
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '', bytes = 0;
  const cancel = () => { void reader.cancel().catch(() => {}); };
  signal?.addEventListener('abort', cancel, { once: true });
  try {
    for (;;) {
      signal?.throwIfAborted();
      const chunk = await reader.read();
      signal?.throwIfAborted();
      if (chunk.done) break;
      bytes += chunk.value.byteLength;
      if (bytes > maxBytes) throw new Error('The reply stream exceeded its limit.');
      buffer += decoder.decode(chunk.value, { stream: true });
      for (;;) {
        const boundary = /\r\n\r\n|\n\n|\r\r/.exec(buffer);
        if (!boundary) break;
        const frame = buffer.slice(0, boundary.index);
        buffer = buffer.slice(boundary.index + boundary[0].length);
        let event = 'message'; const data: string[] = [];
        for (const line of frame.split(/\r\n|\n|\r/)) {
          if (line.startsWith('event:')) event = line.slice(6).trim();
          else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
        }
        if (data.length && await onEvent({ event, data: data.join('\n') }) === false) return;
      }
      if (buffer.length > 128_000) throw new Error('The reply stream frame exceeded its limit.');
    }
    if (buffer.trim()) throw new Error('The reply stream ended unexpectedly.');
  } finally {
    signal?.removeEventListener('abort', cancel);
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}
